import React from "react";
import { Grid, Button } from "@material-ui/core";
import { Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import { TextFieldCommon, ErrorCommon, TextField } from "../../../components/formikFormInputs";
import { Label } from "../../../components/formInputs";



export default function RejectPaymentModel(props: { onSubmit: (values: any, formikProps: FormikHelpers<any>) => void }) {
    const { onSubmit } = props;

    const initialValues = {
        reason: "",
    };

    const ReasonSchema = Yup.object().shape({
        reason: Yup.string().required("Reason is required"),
    });
    // 🔹 Field definitions
    const fieldObj = [
        {
            id: "reason",
            name: "reason",
            label: <Label label={"Reason for rejecting"} required={true} />,
            isRequired: true,
            placeholder: "Enter reason...",
            component: TextField,
            className: "fullWidthcustomFields",
            multiline: true,
            rows: 3,
            size: {
                xs: 12,
            },
        },
    ];

    return (
            <Formik
                    initialValues={initialValues}
                    validationSchema={ReasonSchema}
                    validateOnChange={true}
                    onSubmit={onSubmit}
            >
                {({ values, errors, touched, handleChange, handleSubmit, isSubmitting }) => (
                        <form id={"reject-form"} onSubmit={handleSubmit}>
                            <Grid container spacing={3} className="mt20 mb20">
                                {fieldObj.map((field, index) => (
                                        <Grid item xs={(field.size && field.size.xs as any) || 12} key={index}>
                                            <TextFieldCommon
                                                    {...field}
                                                    values={values}
                                                    onChange={handleChange}
                                            />
                                            <ErrorCommon errors={errors} name={field.name} touched={touched} />
                                        </Grid>
                                ))}
                            </Grid>
                        </form>
                )}
            </Formik>
    );
}
